export default __webpack_public_path__ + "static/media/bg.32ef3d95.jpg";